import { CLEAR_COPY, COPY_SHIFT } from "../Actions/copyActions";

const initialState = {
  copiedShift: {
    userID: "",
    locationID: "",
    startTime: "",
    endTime: "",
    breakStartTime: "",
    breakEndTime: "",
    type: "",
  },
  copy: false,
};

const CopyReducer = (state = initialState, action) => {
  switch (action.type) {
    case COPY_SHIFT:
      return {
        ...state,
        copiedShift: { ...action.payload },
        copy: true,
      };

    case CLEAR_COPY:
      return {
        ...state,
        copiedShift: null,
        copy: false,
      };
    default:
      return state;
  }
};

export default CopyReducer;
